import { render } from "./popUp.vue?vue&type=template&id=132711e9&scoped=true"
import script from "./popUp.vue?vue&type=script&lang=js"
export * from "./popUp.vue?vue&type=script&lang=js"

import "./popUp.vue?vue&type=style&index=0&id=132711e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132711e9"]])

export default __exports__